// Поле «Street Address» молча вырезало всё, кроме букв, цифр, дефиса и слэша.
// Клиент, вписавший туда email, получал адрес вида «officeultdrivecom» — без
// единого предупреждения. Так в IRS ушли формы 1147, 1281 и 1401 одного и того же
// агента. Email теперь не принимаем и сразу говорим почему.

export const EMAIL_IN_STREET_ERROR =
  'This looks like an email address. Please enter the street address, for example 123 Main St.';

export function looksLikeEmail(value) {
  return String(value ?? '').includes('@');
}
